if (!customElements.get("metaobject-product-supplement-facts")) {
  class ProductSupplementFacts extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.loadItems();
      this.loadEvents();
    }

    loadItems() {
      this.dialog = this.querySelector(".supplement-facts-block--dialog");
      this.navigation = this.dialog.querySelector(
        ".supplement-facts-block--dialog-navigation"
      );
      this.openBtn = this.querySelector(".supplement-facts-block--cta");
      this.closeBtn = this.querySelector(".supplement-facts-block--close-dialog");
    }

    loadEvents() {
      this.navigation.addEventListener(
        "click",
        this.navigationHandler.bind(this)
      );

      this.openBtn.addEventListener("click", () => {
        this.dialog.showModal();
      });

      this.closeBtn.addEventListener("click", () => {
        this.dialog.close();
      });

      this.dialog.addEventListener("pointerup", (event) => {
        // If the click is outside of the bounding box of the dialog, close it.
        const rect = this.dialog.getBoundingClientRect();
        const isInDialog =
          rect.top <= event.clientY &&
          event.clientY <= rect.top + rect.height &&
          rect.left <= event.clientX &&
          event.clientX <= rect.left + rect.width;
        if (!isInDialog) {
          this.dialog.close();
        }
      });
    }

    navigationHandler(event) {
      const btn = event.target.closest("button");
      if (!btn) return;
      const { fact } = btn.dataset;

      this.dialog.querySelector(
        `.supplement-facts-block--product[data-fact-active="true"]`
      ).dataset.factActive = false;

      this.navigation.querySelector(
        `button[data-fact-active="true"]`
      ).dataset.factActive = false;

      this.dialog.querySelector(
        `.supplement-facts-block--product[data-fact="${fact}"]`
      ).dataset.factActive = true;

      this.navigation.querySelector(
        `button[data-fact="${fact}"]`
      ).dataset.factActive = true;
    }

    disconnectedCallback() {
      this.navigation.removeEventListener(
        "click",
        this.navigationHandler.bind(this)
      );

      this.openBtn.removeEventListener("click", () => {
        this.dialog.showModal();
      });

      this.closeBtn.removeEventListener("click", () => {
        this.dialog.close();
      });
    }
  }

  customElements.define(
    "metaobject-product-supplement-facts",
    ProductSupplementFacts
  );
}